import React from 'react';
import { Layout } from 'antd';

function MemberFooter() {
    const { Footer } = Layout;

    return <Footer style={{ textAlign: 'center' }}>K2 Digital ©{(new Date()).getFullYear()}</Footer>;
}

export default MemberFooter;